<template>
  <application-layout>
    <v-container>
      <h1>Edit Settings</h1>
      <v-layout column>
        <v-flex class="mt-4">
          <h2>Move In Payment Notes</h2>
          <v-textarea
            data-testid="move-in-payment-notes-textarea"
            class="move-in-payment-notes-textarea mt-2"
            v-model="notesText"
            filled
            label="Move In Payment Notes"
            counter
          />
          <v-layout justify-end>
            <v-btn
              data-testid="save-payment-notes-btn"
              class="save-payment-notes-btn primary"
              @click.native="handleUpdate"
              :loading="loading"
              :disabled="!notesText"
            >
              Save
            </v-btn>
          </v-layout>
        </v-flex>
        <v-flex class="mt-4" v-if="showSpeede">
          <h2>Enable Speederent</h2>
          <v-switch
            v-model="switch1"
            :label="`Speederent enabled: ${switch1.toString()}`"
          ></v-switch>
          <v-layout>
            <v-btn
              class="primary"
              @click.native="handleSpeederentUpdate"
              :loading="loading"
            >
              Save Speederent Setting
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout";

export default {
  name: "SettingsIndex",
  components: { ApplicationLayout },
  data() {
    return {
      loading: false,
      notesText: "",
      switch1: false
    };
  },
  methods: {
    handleUpdate() {
      this.loading = true;
      const payload = {
        id: this.paymentNotes.id,
        label: this.paymentNotes.label,
        ident: this.paymentNotes.ident,
        value: this.notesText
      };
      this.$store.dispatch("updateSettings", payload)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSpeederentUpdate() {
      this.loading = true;
      const payload = {
        id: this.speederentEnabled.id,
        label: this.speederentEnabled.label,
        ident: this.speederentEnabled.ident,
        value: this.switch1.toString()
      };
      this.$store.dispatch("updateSettingsSpeederent", payload)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    showSpeede() {
      let rv = false;
      if (process.env.VUE_APP_SHOW_SPEEDE === "true") {
        rv = true;
      }
      return rv;
    },
    paymentNotes() {
      return this.$store.state.settings.settings.find(setting => setting.label === "Move In Payment Notes");
    },
    speederentEnabled() {
      return this.$store.state.settings.settings.find(setting => setting.label === "Speederent");
    }
  },
  mounted() {
    this.$store.dispatch("getSettings");
  },
  watch: {
    paymentNotes(notesData) {
      if (notesData) {
        this.notesText = notesData.value;
      }
    },
    speederentEnabled(speederentData) {
      if (speederentData) {
        this.switch1 = speederentData.value === "true";
      }
    }
  }
};
</script>
